import ReactDOM from 'react-dom/client';
import './index.css';
import PreloadPage from './components/PreloadPage';
import reportWebVitals from './reportWebVitals';

ReactDOM.createRoot(document.getElementById('root')).render(<PreloadPage />);

reportWebVitals();
